import { Injectable, inject } from '@angular/core';
import { TslApiService } from 'projects/aztalena-core/src/public-api';
import { Observable } from 'rxjs';
import { Tribe } from './tribe';

@Injectable({
  providedIn: 'root'
})
export class TribeService {
  private api = inject(TslApiService);

  getTribes(): Observable<Tribe[]> {
    return this.api.get('tribe/characters');
  }
}
